export const LOCAL_DELIVERY_CATEGORIES = new Set([
  "local",
  "next_day",
  "nextDay",
  "same_day",
  "sameDay"
]);

export const DELIVERY_SPEED_LABELS = {
  local: "Fastest",
  same_day: "Same Day",
  next_day: "Next Day"
};
